// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jc0H","type":"styles_type__WPbCu","choices":"styles_choices__tD3aF"};